/**
 * @author Shalini Jha
 * @desc Side Drawer
 */
import React from 'react';
import PropTypes from 'prop-types';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
const { withStyles } = MaterialUiCore;
const { Drawer } = MaterialUiCore;
export const styles = () => ({
    drawerHeight: {
        '& .MuiPaper-root': {
            minHeight: 260,
            padding: 15,
        },
    },
    drawerWidth: {
        '& .MuiPaper-root': {
            minWidth: 200,
            padding: 15,
        },
    },
});
const drawerPositions = ['top', 'bottom', 'left', 'right'];

const DrawerComponent = ({ classes, children, open, handleClose, position }) => (
    <Drawer
        open={open}
        anchor={drawerPositions.indexOf(position) > -1 ? position : 'right'}
        onClose={handleClose}
        className={position === 'top' || position === 'bottom' ? classes.drawerHeight : classes.drawerWidth}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        {children}
    </Drawer>
);

Drawer.defaultProps = {
    position: 'right',
};
DrawerComponent.propTypes = {
    classes: PropTypes.shape({}).isRequired,
    children: PropTypes.any.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    position: PropTypes.string,
};
export default withStyles(styles)(DrawerComponent);
export { DrawerComponent };
